import { render, staticRenderFns } from "./HeaderSet.vue?vue&type=template&id=1e0c8231&scoped=true&"
import script from "./HeaderSet.vue?vue&type=script&lang=ts&"
export * from "./HeaderSet.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderSet.vue?vue&type=style&index=0&id=1e0c8231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0c8231",
  null
  
)

export default component.exports